import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../Common/Sidebar";
import Loader from "../Common/Loader";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import CommonValues from "../Common/utils";

export default function CDOfficeLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  useEffect(() => {
    const token = CommonValues.GetToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchOffices = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/office/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.offices || [];
        setOffices(data);
      } catch (error) {
        console.error("Error fetching offices:", error);
      }
    };
    const fetchAllData = async () => {
      setLoading(true);
      await fetchOffices();
      setLoading(false);
    };

    fetchAllData();
  }, []);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="office"
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">Offices</h2>
            <p className="text-muted">
             Our office locations around the world
            </p>
          </div>

          <div className="card p-3">
            <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
              <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                  <p className="dashboard-label mb-1">Office Locations</p>
                  <h2 className="dashboard-number mb-1">
                    {Array.isArray(offices) ? offices.length : 0}
                  </h2>
                  <p className="text-muted text-12 mb-0">Global presence</p>
                </div>
                <i className="pi pi-map-marker text-danger fs-1" />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
              <TabView className="mb-2 tabview-tab">
                <TabPanel header="List View">
                  <DataTable
                    value={offices}
                    className="support-call-table custom-bordered-datatable text-14"
                    emptyMessage="No offices found."
                    paginator rows={5}
                  >
                    <Column field="name" header="Office Name" sortable />
                    <Column field="address" header="Address" />
                    <Column field="city" header="City" />
                    <Column field="state" header="State" />
                    <Column field="zip" header="Zip Code" />
                    <Column field="contactNo" header="Contact" />
                  </DataTable>
                </TabPanel>
              </TabView>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
